import ClosingBalanceSheetBalanceColumn from "./ClosingBalanceSheetBalanceColumn.js";
import IncomeStatementAccumulatedColumn from "./IncomeStatementAccumulatedColumn.js";
import IncomeStatementPeriodColumn from "./IncomeStatementPeriodColumn.js";
import ModelFactory from "../../../../ModelFactory.js";
import OpeningBalanceSheetBalanceColumn from "./OpeningBalanceSheetBalanceColumn.js";
import ReportColumn from "./ReportColumn.js";

/**
 * TODO: write documentation
 */
class PeriodReportColumnFactory extends ModelFactory {
	allClasses() {
		return [
			OpeningBalanceSheetBalanceColumn,
			ClosingBalanceSheetBalanceColumn,
			IncomeStatementPeriodColumn,
			IncomeStatementAccumulatedColumn,
		];
	}

	_findClassFromType(type) {
		return super._findClassFromType(type) || ReportColumn;
	}
}

const periodReportColumnFactory = new PeriodReportColumnFactory();

export default periodReportColumnFactory;
